import { LetterSlogan } from "./LetterSlogan"

export const LetterSloganContainer = ({ text }) => {
    return (
        <LetterSlogan text={text} />
    )
}